var _g, _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAiLgFeedback(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 61 30",
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#ai-lg-feedback_svg__clip0_2600_26878)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 35.98,
    y: 1,
    width: 8.02,
    height: 17.819,
    rx: 1,
    fill: "#A8FFF8"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 15,
    y: 11.334,
    width: 10,
    height: 10,
    rx: 5,
    fill: "#CBFF88"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 31,
    y: 22,
    width: 6.555,
    height: 6,
    rx: 3,
    fill: "#CBFF88"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#14454C",
    fillOpacity: 0.15,
    d: "M19.625 4.445h17.93v11.222h-17.93z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.045 3.5c.251 0 .455.204.455.455v15.908a.455.455 0 01-.455.455h-4.848v2.727a.455.455 0 01-.658.407l-6.267-3.134h-7.317a.455.455 0 01-.455-.455V3.955c0-.251.203-.455.454-.455h19.091zM21.41 19.409h6.97l.104.012c.034.009.068.02.1.036l5.705 2.852v-2.446c0-.25.204-.454.455-.454h4.848v-15H21.409v15z",
    fill: "#14454C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.349 9.41a.455.455 0 010 .908h-9.697a.455.455 0 110-.909h9.697zM35.349 13.652a.455.455 0 010 .909h-9.697a.455.455 0 110-.91h9.697z",
    fill: "#14454C"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M50.5 6l.99 2.51L54 9.5l-2.51.99L50.5 13l-.99-2.51L47 9.5l2.51-.99L50.5 6zM59 17l.566 1.434L61 19l-1.434.566L59 21l-.566-1.434L57 19l1.434-.566L59 17zM9.5 21l.99 2.51 2.51.99-2.51.99L9.5 28l-.99-2.51L6 24.5l2.51-.99L9.5 21zM2 16l.566 1.434L4 18l-1.434.566L2 20l-.566-1.434L0 18l1.434-.566L2 16z",
    fill: "#14D1C2"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "ai-lg-feedback_svg__clip0_2600_26878"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(15)",
    d: "M0 0h30v30H0z"
  })))));
}
export default __webpack_public_path__ + "fonts/ai-lg-feedback-02be2fc26b49b8395d052b0a6a7906f1.svg";
export { SvgAiLgFeedback as ReactComponent };